import { RestQueryHookOptions, useRestQuery } from 'utils/hooks/api/useRestQuery';

type QuerySendProgressResponse = {
  size: number;
  sent: number;
};

export const QUERY_REST_PROGRESS_URL = '/i/sendProgress.json';

export const useQuerySendProgress = (
  campaignId: number,
  options?: RestQueryHookOptions<QuerySendProgressResponse>,
) => {
  const {
    isFetching: isLoading,
    data,
    isError: hasError,
    refetch,
    dataUpdatedAt,
  } = useRestQuery(
    QUERY_REST_PROGRESS_URL,
    {
      campaignId,
    },
    { retry: false, refetchOnWindowFocus: false, cacheTime: 0, ...options },
  );

  return { isLoading, sendProgress: data, hasError, dataUpdatedAt, refetch };
};
